import { savedOrderDetailsActionButtonsStyles as styles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.printButton = {
    variant: "secondary",
};

styles.twoButtonModalStyles = {
    ...styles.twoButtonModalStyles,
    submitButton: {
        ...styles.twoButtonModalStyles?.submitButton,
        variant: "primary",
        css: css`
            background-color: ${getColor(colorStrings.primaryMain)};
            border-color: ${getColor(colorStrings.primaryMain)};
        `,
    },
};